<template>
  <div class="page-module-wrap">
    <div class="tabs is-toggl">
      <ul class="">
        <li v-for="(item,index) in categoryList" :class="{ 'is-active': activeIndex == index }" v-on:click="onTabClick(item.type, index)">
          <a><span>{{ item.categoryName }} </span></a>
        </li>
      </ul>
    </div>
    <div class="list-wrap">
      <div class="clearfix">
        <div class="fleft">
          <button class="button is-info margin-right" @click="editType(0)">新增标签</button>
          <span>关键词</span>：
          <input type="text" v-model="search.keyword">
          <button class='button is-primary' @click="searchTag">搜索</button>
        </div>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>标签ID</th>
              <th>标签名</th>
              <th v-if="search.type">添加为运营标签</th>
              <th v-else>前端显示</th>
              <th>待放行/已放行/内容数量</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in list">
              <td>{{item.id}}</td>
              <td>{{item.name}}</td>
              <td v-if="!search.type">
                <el-switch
                  v-model="item.isShow"
                  active-color="#13CE66"
                  active-text=""
                  inactive-text=""
                  @change="switchChange(item,index)"
                >
                </el-switch>
              </td>
              <td v-else>
                <el-switch
                  v-model="item.isAddOperation"
                  active-color="#13CE66"
                  active-text=""
                  inactive-text=""
                  @change="switchChange(item,index)"
                >
                </el-switch>
              </td>
              <td>{{item.waitVerifiedCount}}/{{item.verifiedCount}}/{{item.contentCount}}</td>
              <td>
                <router-link class="button is-success" target="_blank" :to="{name: 'articleList', query: {tagId : item.id,type :type}}">动态</router-link>
                <button class="button is-primary" @click="editType(1,item,index)">编辑</button>
                <button class="button is-danger" @click="deleteTag(item,index)" :disabled="item.showDelete===1">删除</button>
                <span class="red-color" v-if="item.showDelete">删除中</span>
                <span class="blue-color" v-if="item.isAddOperation&&search.type" @click="updateTag(item,index)">更新</span>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="flag?'编辑':'新增'" :visible.sync="dialogFormVisible" :lock-scroll="false"	>
      <div class="margin-left margin-top">
        <p class="margin-top">
            <span class="r-top" v-if="parseInt(params.type)">
              <label>类型:属性标签</label>
            </span>
          <span class="r-top" v-else>
              <label>类型:运营标签</label>
            </span>
        </p>
        <p class="margin-top">
            <span class="">
              <label>标签名:</label>
              <el-input v-model="params.name" class="block width-3" placeholder="请输入内容" v-if="!flag"></el-input>
              <span class="block width-3"  v-else>{{params.name}}</span>
            </span>
        </p>
        <div v-if="!parseInt(params.type)">
          <p class="margin-top">
              <span class="radio r-top">
                <label class="margin-r">是否开启显示:</label>
                <el-radio class="radio" v-model="params.isShow" label="1">是</el-radio>
                <el-radio class="radio" v-model="params.isShow" label="0">否</el-radio>
              </span>
          </p>
          <p class="margin-top">
              <span class="radio r-top">
                <label>是否设为自动打标签:</label>
                <el-radio class="radio" v-model="params.ifAutoTag" label="1">是</el-radio>
                <el-radio class="radio" v-model="params.ifAutoTag" label="0">否</el-radio>
              </span>
          </p>
        </div>
        <div v-else>
          <p class="margin-top">
              <span class="radio r-top">
                <label>是否添加为运营标签:</label>
                <el-radio class="radio" v-model="params.isAddOperation" label="1">是</el-radio>
                <el-radio class="radio" v-model="params.isAddOperation" label="0">否</el-radio>
              </span>
          </p>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelEdit">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">

  export default {
    data(){
      return {
        categoryList: [
          {
            categoryName:"运营标签",
            type:0,
          },
          {
            categoryName:"属性标签",
            type:1,
          },
        ],
        type:0,
        activeIndex: 0,
        categoryName: '',
        categoryId: '',
        list:[],
        count:0,// 有了数据改成0
        search:{
          page:1,
          pageSize:20,
          keyword:'',
          type:0,
        },
        tagId:0,
        flag:false,// true为编辑fasle为新增
        dialogFormVisible:false,
        formLabelWidth:"300",
        params:{
          ifAutoTag:"0",
          isShow:"1",
          type :null,
          name:'',
          showDelete:0,
          isAddOperation:"0",// 属性标签有
          isNewCreate:0,// 新增为1
        },
        indexTemp:null,

      }
    },
    mounted(){
      if (this.$route.query.page) {
        this.search.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.type===0) {
        this.type = 0;
        this.activeIndex = 0;
        this.search.type=0;
      }
      if (this.$route.query.type===1) {
        this.type = 1;
        this.activeIndex = 1;
        this.search.type=1;
      }
      if (this.$route.query.keyword) {
        this.search.keyword=this.$route.query.keyword;
      }

      this.getList(this.search);
    },
    methods:{
      editType(flag,item,index){
        if(flag){
          this.tagId=item.id;
          this.params.type=item.type;
          this.indexTemp=index;
          this.getTag();
        }else{
          this.indexTemp=null;
          this.params.type=this.type;
          this.params.name='';
          this.params.ifAutoTag='0';
          this.params.isShow='1';
          this.params.showDelete='0';
          this.params.isAddOperation='0';
        }
        this.flag=flag;
        this.dialogFormVisible=true;
      },
      cancelEdit(){
        this.dialogFormVisible = false;
      },
      saveEdit(){
        let params = this.params;
        params.tagId = this.tagId;
        if(!params.name){
          this.$message("请输入标签名");
          return
        }
        if(this.flag){
          params.isNewCreate=0;
        }else{
          params.isNewCreate=1;
        }
        HttpRequest.get('/admin.php?method=tagInfo.doSaveTag', params,true).then(response => {
          if (response.data.success) {
            this.$message('保存成功')
            if(this.flag){
              this.list[this.indexTemp].isShow=parseInt(params.isShow)?true:false;
              this.list[this.indexTemp].ifAutoTag=parseInt(params.ifAutoTag)?true:false;
              this.list[this.indexTemp].isAddOperation=parseInt(params.isAddOperation)?true:false;
            }
            this.dialogFormVisible = false;
          }else{
            this.$message(response.data.msg)
          }
        })
      },
      getTag(){
        HttpRequest.post("/admin.php?method=tagInfo.getTag",{tagId:this.tagId,type:this.type}, true).then((response) => {
          this.params = response.data;
          this.params.ifAutoTag=response.data.ifAutoTag+"";
          this.params.isShow=response.data.isShow+"";
          this.params.isAddOperation=response.data.isAddOperation+"";
        }, (response) => {

        });
      },
      handleCurrentChange(value){
        if(this.search.page !== value){
          this.search.page = value;
          this.getList(this.search)
        }
      },
      /**
       * 获取初始化数据列表；
       */
      getList(_params){
        let params = {
          page: _params.page,
          pageSize: _params.pageSize,
          keyword: _params.keyword,
          type: _params.type,
        }
        HttpRequest.get('/admin.php?method=tagInfo.getTagListByType', params).then(response => {
          if (response) {
            this.list = _.toArray(response.data.list);
            this.count = response.data.count;
            if(this.type){
              this.list?this.list.forEach((item,index)=>{
                item.isAddOperation=item.isAddOperation?true:false;
              }):"";

            }else{
              this.list?this.list.forEach((item,index)=>{
                item.isShow=item.isShow?true:false;
              }):"";
            }
            this.search.type=response.data.type;

          }
        });

      },
      searchTag() {
        this.getList(this.search)
      },
      onTabClick(type, index) {
        this.search.page = 1;
        this.activeIndex = index;
        this.search.type=type;
        this.type=type;
        this.search.keyword='';
        this.getList(this.search)
      },
      updateTag(item,index){
        let params={
          tagId:item.id,
          type:item.type,
        }
        HttpRequest.get('/admin.php?method=tagInfo.updateAllArticleInfo',params).then(response => {
          if(!response.result){
            this.$message("已更新成功")
          }else{
            this.$message(response.msg)
          }
        })
      },
      deleteTag(item,index){
        if(!confirm("确认删除?")){
          return false;
        }
        item.showDelete=0;
        let params = {
          tagId: item.id,
          type:item.type,
        }
        HttpRequest.get('/admin.php?method=tagInfo.deleteTag',params).then(response => {
          if(!response.result){
            this.$message('删除成功');
            this.list.splice(index,1)
          }else{
            this.$message(response.msg)
          }
        })
      },
      switchChange(item){
        let params={};
        params.tagId=item.id;
        params.type=item.type;
        params.name=item.name;
        params.showDelete=item.showDelete;
        if(item.type){
          params.isAddOperation=item.isAddOperation?1:0;
          params.isShow=item.isShow;
          params.ifAutoTag=item.ifAutoTag;
        }else{
          params.isAddOperation=item.isAddOperation;
          params.isShow=item.isShow?1:0;
          params.ifAutoTag=item.ifAutoTag;
        }
        HttpRequest.get('/admin.php?method=tagInfo.doSaveTag', params,true).then(response => {
          if (response.data.success) {
            this.$message('保存成功')
          }else{
            this.$message(response.data.msg)
          }
        })

      },
    },

  }
</script>
<style lang="less" scoped>
  .margin-right{
    margin-right: 50px;
  }
  .red-color{
    color:red;
  }
  .blue-color{
    color:blue;
    cursor: pointer;
  }
  .like-tabs {
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
  }
  .like-button {
    padding-left: 10px;
  }
  .likeTabItem{
    line-height: 60px;
    height: 50px;
    font-size: 16px;
    padding: 0 4px;
    box-sizing: border-box;

  }
  .likeTabItem :hover {
    color: #ae0fff
  }
  .active {
    border-bottom: 1px solid #337ab7;
  }
  .search-component {
    display: flex;

    label {
      margin: 5px 5px 0 0;
    }
    .button {
      margin-left: 5px;
    }
  }
  .margin-r{
    margin-right: 41px;
  }
  .btn{
    width:40px;
    height:20px;
    border-radius: 10px;
    background-color: #13CE66;
    border-width: 1px;
    .point{
      float:right;
      width:20px;
      height:20px;
      border-width: 1px;

      border-radius: 100%;
      background-color: #fff;
    }
  }
  .disableBtn{
    width:40px;
    height:20px;
    border-radius: 10px;
    background-color: #cccccc;
    border-width: 1px;
    .point{
      float:left;
      width:20px;
      height:20px;
      border-width: 1px;

      border-radius: 100%;
      background-color: #fff;
    }
  }
</style>
